import {
	cofReducer as CoFConfig,
	initState as cofInitState,
} from './CoF.reducers';
import {
	componentReducer as ComponentStore,
	initState as componentInitState,
} from './component.reducers';
import {
	lofReducer as LoFConfig,
	initState as lofInitState,
} from './LoF.reducers';
import {
	riskReducer as RiskStore,
	initState as riskInitState,
} from './Risk.reducers';
import {
	assetReducer as assetFields,
	initState as assetFieldsState,
} from './asset.reducers';

import { StoreState } from '@Types';
import { combineReducers } from 'redux';
import { moduleNamespace } from '@Store/config.store';
import { utilReducer as util } from './util.reducer';
import { utilStoreStateInitial } from '@Types/utils.types';

export const initialState: StoreState = {
	LoFConfig: lofInitState,
	CoFConfig: cofInitState,
	RiskStore: riskInitState,
	assetFields: assetFieldsState,
	ComponentStore: componentInitState,
	util: utilStoreStateInitial(),
};

export default combineReducers({
	LoFConfig,
	CoFConfig,
	RiskStore,
	assetFields,
	ComponentStore,
	util,
});

export const reducerKey = moduleNamespace;
